import { Button } from "components/Form/Button"

interface ErrorComponentProps {
  onReset: () => void
}

export const ErrorComponent = ({ onReset }: ErrorComponentProps) => {
  return (
    <div className="mx-auto py-10 w-96 text-center">
      <h2 className="font-base mb-10 font-semibold">مشکلی پیش آمده است!</h2>
      <div className="flex justify-center">
        <Button onClick={onReset} label="تلاش مجدد!" />
      </div>
    </div>
  )
}
